import {Injectable} from 'ng-metadata/core';


@Injectable()
export class FormFieldService {
    private _data;
    constructor() {
    }
    
    /* getters /setters */
    get data() {
        return this._data;
    }
    
    set data(data) {
        this._data= data;
    }
}
//put here all angular1 modules the service is using
export default [];


// WEBPACK FOOTER //
// ./src/main/webapp/components/infra/formBuilder/field/formField.service.ts